module.exports = __webpack_public_path__ + "img/adhd.fc0f7589.jpg";